// MUST be the first import - Sentry initialization
import "./instrument";
import * as Sentry from "@sentry/react";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

const root = ReactDOM.createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.error("Uncaught error:", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
      <Sentry.ErrorBoundary 
        fallback={({ error, resetError }) => (
          <div style={{ 
            padding: "40px", 
            textAlign: "center",
            fontFamily: "system-ui, -apple-system, sans-serif",
            backgroundColor: "#1a1a2e",
            minHeight: "100vh",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <h1 style={{ fontSize: "24px", marginBottom: "16px" }}>
              Une erreur inattendue s'est produite
            </h1>
            <p style={{ color: "#9ca3af", marginBottom: "24px" }}>
              Notre équipe a été notifiée. Veuillez rafraîchir la page ou réessayer.
            </p>
            <details style={{ 
              marginTop: "20px", 
              textAlign: "left",
              maxWidth: "600px",
              width: "100%"
            }}>
              <summary style={{ cursor: "pointer", color: "#60a5fa" }}>
                Détails de l'erreur
              </summary>
              <pre style={{ 
                backgroundColor: "#0f0f1a", 
                padding: "16px", 
                borderRadius: "8px",
                overflowX: "auto",
                fontSize: "12px",
                marginTop: "12px"
              }}>
                {error.toString()}
              </pre>
            </details>
            <button 
              onClick={resetError}
              style={{
                marginTop: "24px",
                padding: "12px 24px",
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500"
              }}
            >
              Réessayer
            </button>
          </div>
        )}
        beforeCapture={(scope) => {
          scope.setTag("error_boundary", "app_root");
        }}
      >
        <App />
      </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
